import { useReducer } from 'react';
import { useLocation } from 'react-router-dom';
import { HouseholdInfoResponse } from '../crm-application-eligibility/types/apiResponse';
import { api,replaceParamsInStr } from '../common-utils-services/axiosUtil';
import endpoints from '../../constants/configs/endpoints';
import { IEnvironmentResponse } from './types/apiResponse';
import { convertQueryParamsStringToQueryParamsObject } from '../../utils/miscellaneous/urlSearchParams';


// endpoints
const applicationEligibilityData = '../../../mocks/crm/applicationEligibilityData.json';
const ENVIRONMENT = '/mocks/invoicingManagement/environment.json';


enum actions {
    FETCH_HOUSHOLDS_DATA = 'FETCH_HOUSHOLDS_DATA',
    DATA_ERROR = 'DATA_ERROR'
}

const initialState = {
    houseHoldInfo: {}
};

type Action =
| { type: 'FETCH_HOUSHOLDS_DATA'; payload: HouseholdInfoResponse }
| { type: 'DATA_ERROR'; payload: undefined }
| { type: 'FETCH_ENV_DATA'; payload: IEnvironmentResponse }


function reducer(state: any, action: Action) {
    switch (action.type) {
        case actions.FETCH_HOUSHOLDS_DATA:{
            const response = action.payload
            return {
                ...state,
                houseHoldInfo: response
            }
        }
        case actions.DATA_ERROR:
            return  { ...state, isError: true }
        default:
            return state;
    }
}

export default () => {
    const [data, dispatch] = useReducer(reducer, initialState);
    const { search } = useLocation();
    const getUserId = () => {
        const queryParams = convertQueryParamsStringToQueryParamsObject(search);
        if(queryParams.hasOwnProperty('userId')) {
            sessionStorage.setItem('ivm_userId', queryParams.userId);
            return queryParams.userId;
        }
        return sessionStorage.getItem('ivm_userId');

    };

    const getEnvironmentData = async (props) => {

        const userId = getUserId();
        try {
            const url = global.__ENV__.PRODUCTION
                ? `${endpoints.IVM_ENVIRONMENT}?userId=${userId}`
                : ENVIRONMENT;
            const res = await api.get<IEnvironmentResponse>(url);
            if (res?.data) {
                dispatch({ type: 'FETCH_ENV_DATA', payload: { ...res.data } });
            }
            return res?.data;
        } catch (e) {
            dispatch({ type: 'DATA_ERROR', payload: undefined });
            console.log(
                `In Invoicing Management: getEnvironmentData(): Request to (${endpoints.IVM_ENVIRONMENT}) failed with error = `,
                e
            );
        }
    };
    const fetchApplicationEligibilityData = async (caseNumber: string) => {
        try {
            const url = global.__ENV__.PRODUCTION
                ? `${endpoints.FETCH_HOUSHOLDS_ELIGIBILITY}`
                : applicationEligibilityData;

            const endpoint = replaceParamsInStr(url, { caseNumber: caseNumber});

            const res = await api.get<HouseholdInfoResponse>(endpoint);
            if (res?.data) {
                dispatch({ type: 'FETCH_HOUSHOLDS_DATA', payload: { ...res.data } });
            }
            return res?.data;
        } catch (e) {
            dispatch({ type: 'DATA_ERROR', payload: undefined });
            console.log(
                `In Invoicing Management: fetchApplicationEligibilityData(): Request to (${endpoints.FETCH_HOUSHOLDS_ELIGIBILITY}) failed with error = `,
                e
            );
        }
    };

    return {
        data,
        fetchApplicationEligibilityData: (caseNumber: string) => {
            return fetchApplicationEligibilityData(caseNumber);
        },
        getEnvironmentData: (userId: any)=>getEnvironmentData
    }

}